import { SCHOOLS } from "../../../graphql/school";
  import { client } from '../../utilities/config';
  
  export const getSchools = () => {
    return client.query({
      fetchPolicy: "no-cache",
      query: SCHOOLS
    });
  };
  